import { render, staticRenderFns } from "./EchartsBar.vue?vue&type=template&id=77c57e54&scoped=true&"
import script from "./EchartsBar.vue?vue&type=script&lang=js&"
export * from "./EchartsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c57e54",
  null
  
)

export default component.exports